import React from 'react';
import CauseImage from '../../ServiceComponents/CausesSection/CauseImage';
import BookOnlineSection from '../../ServiceComponents/BookOnlineSection';

const SpecialtiesSymptoms = ({causes = []}) => {
  return (
    <section className="bg-gray-100 py-12">
      <div className="flex w-full flex-col items-center justify-center px-4">
        <h2 className="text-3xl sm:text-4xl text-primary pb-4 font-bold text-center mb-8">Symptoms</h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full max-w-6xl mx-auto">
          {/* Image on top for small screens */}
          
          
          <div className="order-1 lg:order-1">
            {causes.map((cause, index) => (
              <div key={index} className="mb-8">
                <h3 className="text-2xl font-bold text-primary mb-2">{cause.title}</h3>
                <p className="text-gray-700 text-lg text-justify w-[90%]">{cause.description}</p>
              </div>
            ))}
          </div>
          {/* Right Column: Sticky Image */}
          <div className="lg:order-2">
            <div className="sticky top-20">
              <BookOnlineSection/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SpecialtiesSymptoms;
